import { Component, WritableSignal, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ResourceService } from '../../services/resource.service';
import { IResource } from '../../interfaces/iresource';
import { tap } from 'rxjs';
import { AuthService } from '@core/services/auth.service';
import { ILoginResponse } from '@core/interfaces/ilogin-response';
import { Role } from '@core/enums/roles';
import { Card } from '@core/models/card';
import { CardService } from '@core/services/card.service';

@Component({
  selector: 'prism-external-resources',
  templateUrl: './external-resources.component.html',
  styleUrl: './external-resources.component.scss'
})
export class ExternalResourcesComponent {
  private resourceService = inject(ResourceService);
  private authService = inject(AuthService);
  private cardService = inject(CardService);
  private router = inject(Router);
  private resourceContainer = 'resources';

  currentUser: WritableSignal<ILoginResponse | null> = this.authService.currentUserInfo;
  resources: IResource[] = [];
  sasToken: string = '';
  canAdd: boolean = false;

  viewResource = (card: Card) => this.cardService.viewCard(card.id!, '/resources/view/');

  get resourceList(): Card[] {
    if (this.resources.length === 0) return [];
    return this.cardService.mapCardDataToDataList(this.resourceContainer, this.resources, this.sasToken);
  }

  ngOnInit(): void {
    this.getSasToken();
    this.canAdd = this.currentUser()?.roleId === Role.SystemAdmin;
  }

  getSasToken(): void {
    this.authService.fetchSasToken(this.resourceContainer, (token) => {
      this.sasToken = token;
      this.getResources();
    });
  }

  goToResourcesForm(): void {
    this.router.navigateByUrl('/resources/form');
  }

  getResources(): void {
    this.resourceService.getResources().pipe(
      tap((res: IResource[]) => {
        this.resources = res;
      })
    ).subscribe();
  }
}
